import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useWindowEvent } from '@mantine/hooks';

import { publicConfig } from '@public-config';

import { useCurrentUser } from 'hooks/use-current-user';
import { AuthenticationService } from 'services/AuthenticationService';
import { InternalTrackingService } from 'services/InternalTrackingService';
import { ModalService } from 'services/ModalService';
import { UserService } from 'services/UserService';

let staleReleasePrompted = false;

const useHeartbeat = () => {
    const router = useRouter();
    const user = useCurrentUser();

    const check = () => {
        if (!user?.id) {
            return;
        }

        UserService.heartbeat().then(async (heartbeat) => {
            if (typeof heartbeat === 'object' && 'authenticated' in heartbeat) {
                if (!heartbeat.authenticated) {
                    InternalTrackingService.track('user.session.expired', {
                        user,
                    });

                    await AuthenticationService.logout('expired');
                    return;
                }

                if (
                    !staleReleasePrompted &&
                    publicConfig.release &&
                    heartbeat.release &&
                    heartbeat.release !== publicConfig.release
                ) {
                    staleReleasePrompted = true;

                    ModalService.openConfirmModal({
                        modalId: 'stale-release',
                        centered: true,
                        title: 'A new version is available',
                        children:
                            'We released an update since you opened this page. Reload to get the latest features and fixes.',
                        labels: { confirm: 'Reload now', cancel: 'Later' },
                        onConfirm: () => {
                            window.location.reload();
                        },
                    });
                }
            } else {
                console.error('Unexpected heartbeat response', heartbeat);
            }
        });
    };

    useEffect(() => {
        check();
    }, [router.pathname, user?.id]);

    useWindowEvent('focus', () => {
        check();
    });
};

export { useHeartbeat };
